__turbopack_context__.v({
  "className": "robotolight_79257b2f-module__Yq2zvW__className",
  "variable": "robotolight_79257b2f-module__Yq2zvW__variable",
});
